// Recovered compiled webpack factory 19649. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  function r(e, t) {
    let r = Object.keys(e);
    if (r.length !== Object.keys(t).length) return !1;
    for (let n = r.length; n--; ) {
      let a = r[n];
      if ("query" === a) {
        let r = Object.keys(e.query);
        if (r.length !== Object.keys(t.query).length) return !1;
        for (let n = r.length; n--; ) {
          let a = r[n];
          if (!t.query.hasOwnProperty(a) || e.query[a] !== t.query[a]) return !1;
        }
      } else if (!t.hasOwnProperty(a) || e[a] !== t[a]) return !1;
    }
    return !0;
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "compareRouterStates", {
      enumerable: !0,
      get: function () {
        return r;
      },
    }));
}
